import { AuthState } from "../../../types/login";
import {
  //AuthActions,
  SET_LOGIN,
  SET_LOGOUT,
} from "../../actions-Types/actionTypes";
import { AnyAction } from "@reduxjs/toolkit";

const initialState: AuthState = {
  loginDetials: null,
};

const authReducer = (state: AuthState = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_LOGIN:
      return { ...state, loginDetials: action.payload };
    case SET_LOGOUT:
      return { ...state, loginDetials: null };
    default:
      return state;
  }
};

export default authReducer;
